<template>
  <div class="elec-infor">
    <ul class="u-myflex u-color-white u-flexwrap">
      <li class="u-w-50">
        <span>左侧是否放下遮阳板：</span
        >{{ data.leftShield == 0 ? '收起' : '放下' }}
      </li>
      <li class="u-w-50">
        <span>右侧是否放下遮阳板：</span
        >{{ data.rightShield == 0 ? '收起' : '放下' }}
      </li>
      <li class="u-w-50">
        <span>副驾是否有人：</span>{{ data.rightSeated != null ? data.rightSeated == 0 ? '否' : '是' :'未知'}}
      </li>
      <li class="u-w-50">
        <span>左侧驾驶室是否系安全带：</span
        >{{ data.leftBelt == 0 ? '否' : '是' }}
      </li>
      <li class="u-w-50">
        <span>右侧驾驶室是否系安全带：</span
        >{{ data.rightBelt == 0 ? '否' : '是' }}
      </li>
      <li class="u-w-50">
        <span>是否有天窗：</span>{{ data.hasRoofWindow == 0 ? '否' : '是' }}
      </li>
      <li class="u-w-50"><span>速度：</span>{{ data.speed }}</li>
      <li class="u-w-50"><span>车道号：</span>{{ data.laneNo }}</li>
      <li class="u-w-100">
        <span>motorvehicleID：</span>{{ data.motorvehicleID }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss">
.elec-infor {
  display: flex;
  ul {
    li {
      text-align: left;
      padding: 20px 0;
      color: #e1e1e1;
      span {
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
  > div {
    flex: 1;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cards-info/elecInfor.vue